import React, { useCallback, useMemo } from 'react'
import { useStore, useDispatch, useSelector } from 'react-redux'
import { moduleContext } from 'react-contextual'
import { path, pathOr, findIndex } from 'ramda'
import history from '../../state/history'
import { uiEvents } from '../ui'
import { layoutEvents, layoutSelectors } from '../Layout/state'
import { $TSFixMe } from 'types/ts-migrate'
import { propertySelectors } from './state'
import { NAMESPACE } from './constants'
import { propertyApiEvents, propertyApiSelectors } from 'modules/api/property'

const PropertiesProvider = moduleContext()(({ context, children, ...props }: $TSFixMe) => {
  const store = useStore()
  const dispatch = useDispatch()

  const { match } = props
  const { params } = match
  const id = pathOr('', ['id'], params)
  const location = useSelector(state => pathOr('', ['router.location'], state))

  const resetLayout = () => {
    dispatch(layoutEvents.closePrimaryPanel(NAMESPACE))
    dispatch(layoutEvents.openSidebar('global'))
  }

  // Stable reference: consumers use this in effect dependency arrays. A fresh closure
  // per render re-fires those effects on every store update, which after a failed
  // request (error action -> re-render -> effect -> request) loops indefinitely.
  const fetchProperty = useCallback((id: any) => dispatch(propertyApiEvents.property_request({ id })), [dispatch])

  const state = store.getState()
  const currentPropertyId = id
  const currentProperty = propertyApiSelectors.getPropertyById(state)(id)

  const propertiesStore = {
    match,
    location,
    currentPropertyId,
    currentProperty,
    propertyFilters: useSelector(propertySelectors.getPropertyFilters),
    viewData: useSelector(state => propertySelectors.getPropertyViewData(state)(id)),
    propertyViewId: id,
    pathname: useSelector(state => state.router.location.pathname),
    primaryPanel: useSelector(state => layoutSelectors.getPrimaryPanel(state)(NAMESPACE)),
    initialValuesForEdit: useSelector(state => propertySelectors.getInitialValuesForEdit(state)(id)),
    createProperty: (payload: any) => dispatch(propertyApiEvents.createProperty_request(payload)),
    fetchProperties: () => dispatch(propertyApiEvents.properties_request()),
    fetchSearchResults: (query: any) => dispatch(propertyApiEvents.search_request({ query })),
    fetchGooglePlace: (placeId: any) => dispatch(propertyApiEvents.place_request({ placeId })),
    fetchProperty,
    openProperty: (id: any) => {
      dispatch(layoutEvents.closeSidebar('global'))
      dispatch(layoutEvents.openPrimaryPanel(NAMESPACE))
      dispatch(uiEvents.redirect(`/properties/${id}`))
    },
    openEditProperty: (id: any) => {
      dispatch(layoutEvents.closeSidebar('global'))
      dispatch(layoutEvents.openPrimaryPanel(NAMESPACE))
      dispatch(uiEvents.redirect(`/properties/${id}/edit`))
    },
    closeProperty: () => {
      dispatch(uiEvents.redirect('/properties'))
      resetLayout()
    },
    updateCurrentProperty: (values: any) => {
      dispatch(propertyApiEvents.updateProperty_request({ id: currentPropertyId, values }))
    },
    resetLayout,
    redirect: (path: any) => dispatch(uiEvents.redirect(path)),
    /** @todo move to general app provider */
    goBack: () => history.goBack(),
    ...props,
  }
  return <context.Provider value={propertiesStore}>{children}</context.Provider>
})

export default PropertiesProvider
